import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { first } from 'rxjs/operators';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { Locality } from 'src/app/core/models';
import { FilterService } from 'src/app/core/services/filter.service';
@Component({
  selector: 'app-louer-bien',
  templateUrl: './louer-bien.component.html',
  styleUrls: ['./louer-bien.component.scss'],
})
export class LouerBienComponent implements OnInit, OnDestroy {
  searchForm!: FormGroup;
  inputStream$: Subscription = new Subscription();
  searchedAddresses: Locality[] = [];
  inputChange$!: Observable<string>;
  choosedLocality?: Locality | null;
  actionFromChoosedLocality?: boolean = false;
  submitted = false;
  checkdistance = false;

  @ViewChild('locality') locality!: ElementRef<HTMLElement>;

  constructor(
    private filterService: FilterService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    this.createSearchForm();
    this.beginSearch();
    this.onCheckboxDistance(false);
  }

  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      locality: ['', Validators.required],
      budget: [''],
      distance: [''],
      type: [''],
    });
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.searchForm.controls;
  }
  beginSearch(): void {
    if (this.searchForm) {
      this.inputChange$ = this.searchForm.controls.locality.valueChanges;
      this.searchedAddresses = [];
      this.inputStream$ = this.inputChange$
        .pipe(
          map((e: string) => e),
          debounceTime(400),
          distinctUntilChanged(),
          startWith('')
        )
        .subscribe((c) => {
          if (!this.actionFromChoosedLocality) {
            this.choosedLocality = null;
            if (this.searchForm.controls.locality.value) {
              this.filterService
                .searchBackendLocalities(
                  this.searchForm.controls.locality.value,
                  this.checkdistance ? '/google' : ''
                )
                .pipe(first())
                .subscribe((response: any) => {
                  this.searchedAddresses = response.data;
                });
            } else {
              this.searchedAddresses = [];
            }
          } else {
            this.actionFromChoosedLocality = false;
          }
        });
    }
  }

  chooseLocality(item: Locality) {
    this.actionFromChoosedLocality = true;
    this.choosedLocality = item;
    this.searchForm.patchValue({
      locality: this.textLocality(item),
    });
    this.searchedAddresses = [];
  }

  textLocality(item: Locality | null | undefined) {
    let localityText = item?.nom_commune + ' ' + item?.code_postal;
    localityText = item?.ville ? item.ville : localityText;
    return localityText;
  }
  cancelSearchingAddress() {
    this.searchedAddresses = [];
  }

  submitFormSearch() {
    this.submitted = true;
    if (!this.choosedLocality) {
      this.searchForm.patchValue({
        locality: '',
      });
    }
    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }
    let localityQuery = this.textLocality(this.choosedLocality);
    void this.router.navigate([
      `/biens-a-louer/${localityQuery}/${
        this.f.budget.value ? this.f.budget.value : null
      }/${this.f.distance.value ? this.f.distance.value : null}/${
        this.f.type.value ? this.f.type.value : null
      }`,
    ]);
  }

  onCheckboxDistance(event: any) {
    if (!event) {
      this.checkdistance = false;
    } else {
      this.checkdistance = event?.target?.value == 2 ? true : false;
    }
    this.searchForm.patchValue({
      locality: '',
      distance: '',
    });
    this.choosedLocality = null;
    // update distance validity
    if (this.checkdistance) {
      this.searchForm.patchValue({
        distance: 10,
      });
      this.searchForm.controls.distance.setValidators([
        Validators.required,
        Validators.maxLength(200),
      ]);
    } else {
      this.searchForm.controls.distance.setValidators([
        Validators.maxLength(200),
      ]);
    }
    this.searchForm.controls.distance.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    this.inputStream$.unsubscribe();
  }
}
